import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCFDMessageReceiptErrorDialog } from '../Selectors'
import { setMessageReceiptErrorDialog } from '../ActionCreators'
import ConfirmModal from '../../components/ConfirmModalV2'
import { sendCFDScreenNav } from '../../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { resetCFD } from '../../VNCustomerFacingDisplay/ActionCreators'
import { CFD_SCREEN } from '../../VNCustomerFacingDisplay/Reducer'

/**
 * @todo [T42290] show error dialog notifying user of workstation connection issue
 */
export const VNCFDCommunicationErrorDialog = () => {
  const dispatch = useDispatch()
  const isOpen = useSelector(getCFDMessageReceiptErrorDialog)

  if (!isOpen) {
    return null
  }

  return (
    <ConfirmModal
      open={isOpen}
      singleButtonOnly
      headerText={'Card Reader Communication Error.'}
      subtext={'Reboot Workstation and Retry.'}
      buttonTwoText={'OKAY'}
      onButtonTwoClick={() => {
        // reset CFD
        dispatch(resetCFD(true, true))
        sendCFDScreenNav(CFD_SCREEN.CART)

        // hide "Customer Entering Tip" modal

        // dismiss error dialog
        dispatch(setMessageReceiptErrorDialog(false))
      }}
    />
  )
}
